import { isMatch, isString } from 'lodash-es';
let registry = [];
export function clearRegistry() {
    registry = [];
}
export function registerExecutor(...args) {
    registry.push({
        id: isString(args[0]) ? args[0] : undefined,
        executor: args[args.length - 1],
        variables: args.length === 3 ? args[1] : undefined,
    });
}
function matchVariables(matcher, variables) {
    if (typeof matcher === 'undefined') {
        return true;
    }
    if (typeof matcher === 'function') {
        return matcher(variables);
    }
    return isMatch(variables, matcher);
}
function getCandidates(id) {
    return registry.filter((entry) => id === entry.id || entry.id === undefined);
}
function formatEntry(id, variables) {
    return `  ${id ? id : '*'}:${variables ? JSON.stringify(variables) : '*'}`;
}
class ExecutorRegistryError extends Error {
    constructor(id, variables) {
        const candidates = getCandidates(id);
        const candidatesMessage = candidates.length > 0
            ? [
                'Candidates:',
                ...candidates.map(({ id, variables }) => formatEntry(id, variables)),
            ]
            : [];
        super([
            'No executor found for:',
            formatEntry(id, variables),
            ...candidatesMessage,
        ].join('\n'));
        this.name = 'ExecutorRegistryError';
    }
}
/**
 * Create an executor from the registry.
 *
 * @param id
 *   The operation ID, from the schema package.
 * @param variables
 *   A dictionary of variables to be passed to the operation.
 */
export function createExecutor(id, variables) {
    const op = getCandidates(id)
        .filter((entry) => matchVariables(entry.variables, variables))
        .pop();
    if (op) {
        if (typeof op.executor === 'function') {
            return () => op.executor(id, variables);
        }
        return op.executor;
    }
    throw new ExecutorRegistryError(id, variables);
}
